import { render, staticRenderFns } from "./SiteChips.vue?vue&type=template&id=5f0f8caf"
import script from "./SiteChips.vue?vue&type=script&lang=js"
export * from "./SiteChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports